import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { ExportBtn, Section } from './PosBits';
import { PosTable } from './PosTable';
import { inr, useDebounced, usePaged } from './posUtils';

const MN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

const MonthSel = ({ value, onChange, testid }) => (
  <Select value={String(value)} onValueChange={(v) => onChange(Number(v))}>
    <SelectTrigger className="h-9 w-24" data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{MN.map((m, i) => <SelectItem key={m} value={String(i + 1)}>{m}</SelectItem>)}</SelectContent>
  </Select>
);

export const HistoryTab = ({ latest, openCustomer }) => {
  const [year, setYear] = useState(Number((latest || String(new Date().getFullYear())).slice(0, 4)));
  const [fm, setFm] = useState(1);
  const [tm, setTm] = useState(12);
  const [name, setName] = useState('');
  const [mobile, setMobile] = useState('');
  const params = { year, from_m: Math.min(fm, tm), to_m: Math.max(fm, tm) };
  const dn = useDebounced(name); const dm = useDebounced(mobile);
  const qp = { ...params, ...(dn ? { name: dn } : {}), ...(dm ? { mobile: dm } : {}) };
  const t = usePaged('history', qp, 'total_sales');
  const d = t.data;
  const withData = new Set(d?.months_with_data || []);
  const cols = [
    { key: 'customer_id', label: 'ID' },
    { key: 'name', label: 'Name', render: (v) => <b>{v}</b> },
    { key: 'mobile', label: 'Mobile', sortable: false },
    ...(d?.months || []).map((m) => ({
      key: m, label: MN[Number(m.slice(5)) - 1], align: 'right',
      render: (v) => (v != null ? inr(v) : <span className={withData.has(m) ? 'text-slate-300' : 'text-slate-200'}>{withData.has(m) ? '0' : '·'}</span>),
    })),
    { key: 'total_sales', label: 'Total Sales', align: 'right', render: (v) => <b className="text-emerald-700">{inr(v)}</b> },
  ];
  const years = Array.from({ length: 6 }, (_, i) => new Date().getFullYear() + 1 - i);
  return (
    <Section title="Monthly Customer History" testid="history-tab" right={<ExportBtn section="history" params={qp} testid="export-history-btn" />}>
      <div className="flex flex-wrap gap-2 mb-3 items-center">
        <Select value={String(year)} onValueChange={(v) => setYear(Number(v))}>
          <SelectTrigger className="h-9 w-24" data-testid="history-year"><SelectValue /></SelectTrigger>
          <SelectContent>{years.map((y) => <SelectItem key={y} value={String(y)}>{y}</SelectItem>)}</SelectContent>
        </Select>
        <MonthSel value={fm} onChange={setFm} testid="history-from-month" />
        <span className="text-slate-400 text-sm">to</span>
        <MonthSel value={tm} onChange={setTm} testid="history-to-month" />
        <Input className="h-9 w-44" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} data-testid="history-name" />
        <Input className="h-9 w-44" placeholder="Mobile" value={mobile} onChange={(e) => setMobile(e.target.value)} data-testid="history-mobile" />
        {d && <span className="text-xs text-slate-500 ml-auto" data-testid="history-grand-total">Grand total {inr(d.grand_total)}</span>}
      </div>
      <PosTable columns={cols} rows={d?.items} sort={t.sort} order={t.order} onSort={t.onSort} page={t.page} total={d?.total}
        onPage={t.setPage} loading={t.loading} testid="history-table" onRowClick={(r) => openCustomer(r.customer_id)} />
      <p className="text-[11px] text-slate-500 mt-2">“0” = month imported but no purchase; “·” = month not imported.</p>
    </Section>
  );
};
